var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailabilityIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A2A2A0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.649 2.97l.146.11c.274.207.66.148.863-.131.203-.28.145-.673-.13-.879L10.11 1.004c-.275-.207-.661-.147-.864.132-.203.279-.145.672.13.878l.146.11-.426.585c-.737-.49-1.59-.816-2.505-.927v-.526h.181c.341 0 .618-.281.618-.628S7.113 0 6.772 0H5.007c-.341 0-.617.281-.617.628s.276.628.617.628h.182v.526c-.917.11-1.768.436-2.506.927l-.425-.585.146-.11c.275-.206.332-.6.13-.878-.203-.28-.59-.338-.864-.132L.25 2.07c-.274.206-.332.6-.13.879.203.279.59.338.864.132l.147-.11.477.657C.618 4.7.008 6.136.008 7.718c0 3.299 2.638 5.983 5.882 5.983 3.243 0 5.882-2.684 5.882-5.983 0-1.582-.61-3.019-1.6-4.09l.477-.657zm-.288 4.748c0 2.507-2.006 4.547-4.471 4.547-2.465 0-4.47-2.04-4.47-4.547 0-2.507 2.005-4.547 4.47-4.547s4.47 2.04 4.47 4.547z",
    transform: "translate(.688 .083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89 4.09v7.256c1.966 0 3.567-1.628 3.567-3.628S7.857 4.09 5.89 4.09z",
    transform: "translate(.688 .083)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailabilityIcon);
export default __webpack_public_path__ + "static/media/availability-icon.b999574a63ee6a5fce4d17ff0ae9c8f8.svg";
export { ForwardRef as ReactComponent };